import React, { useState } from "react";
import {
  Row,
  Col,
  Spin,
  Form,
  Card,
  Select,
  InputNumber,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import cnt from "../../../../services/definedConstant";
import { rightAction } from "../../../../redux/actions";
import {
  labelConfig,
  staticConfig,
  apiConfig,
} from "../../treasuryContractBooking.config";
import { BOM } from "../../../../services/definedMethod";

const CreateAuctionBid = (props) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [portfolioOptions, setPortfolioOptions] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams(); // auctionId

  const onFinish = async (values) => {
    try {
      setIsLoading(true);

      const payload = {
        portfolioId: values.portfolioId,
        bidAmount: values.bidAmount,
        bidPrice: values.bidPrice,
        bidYield: values.bidYield,
      };

      // await BOM.SendReq(apiConfig.createAuctionBid, { auctionId: id, ...payload });
      console.log("CreateAuctionBid payload:", payload);
      BOM.AlertMsg(cnt.SUCCESS, "Auction bid created successfully.");
      navigate(-1);
    } catch (error) {
      BOM.AlertMsg(cnt.DANGER, error?.message || "Failed to create auction bid.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MainLayout pageItems={staticConfig.newAuction}>
      <TopContent pageTitle={labelConfig.securityProduct} />

      <Spin spinning={isLoading} size="large">
        <div style={{ padding: "24px" }}>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            <h3 style={{ marginBottom: 24, fontWeight: 600 }}>
              Create Auction Bid
            </h3>

            <Form layout="vertical" form={form} onFinish={onFinish}>

              {/* Portfolio & Bid Amount */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Portfolio
                        <Tooltip title="The portfolio placing this auction bid.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="portfolioId"
                    rules={[{ required: true, message: "Portfolio is required" }]}
                  >
                    <Select
                      style={{ height: 44 }}
                      suffixIcon={<ChevronDown color="#667085" />}
                      options={portfolioOptions}
                      placeholder="Select Portfolio"
                      showSearch
                      optionFilterProp="label"
                    />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Bid Amount
                        <Tooltip title="The face value amount being bid at this auction.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="bidAmount"
                    rules={[
                      { required: true, message: "Bid amount is required" },
                      { type: "number", min: 1, message: "Bid amount must be greater than 0" },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%", height: 44 }}
                      placeholder="e.g. 50,000,000.00"
                      formatter={(value) =>
                        value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
                      }
                      parser={(value) => value?.replace(/,/g, "")}
                      precision={2}
                      min={0}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Bid Price & Bid Yield */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Bid Price
                        <Tooltip title="The price per 100 face value at which the bid is placed.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="bidPrice"
                    rules={[
                      { required: true, message: "Bid price is required" },
                      { type: "number", min: 0, max: 100, message: "Bid price must be between 0 and 100" },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%", height: 44 }}
                      placeholder="e.g. 98.50"
                      precision={2}
                      min={0}
                      max={100}
                    />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Bid Yield (%)
                        <Tooltip title="The annualised yield rate at which the bid is placed.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="bidYield"
                    rules={[
                      { required: true, message: "Bid yield is required" },
                      { type: "number", min: 0, message: "Bid yield must be 0 or greater" },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%", height: 44 }}
                      placeholder="e.g. 12.50"
                      precision={2}
                      min={0}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Divider */}
              <div style={{ borderTop: "1px solid #EAECF0", margin: "8px 0 20px" }} />

              {/* Action Buttons */}
              <Row justify="end">
                <Col>
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      background: "#fff",
                      color: "#344054",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                      marginRight: 12,
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={() => form.submit()}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #BA24D5",
                      background: "#BA24D5",
                      color: "#fff",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                    }}
                  >
                    Submit
                  </button>
                </Col>
              </Row>

              <button type="submit" hidden />
            </Form>
          </Card>
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, { rightAction })(CreateAuctionBid);